import { render, staticRenderFns } from "./AuthCallback.vue?vue&type=template&id=4710a540&scoped=true"
import script from "./AuthCallback.vue?vue&type=script&lang=ts"
export * from "./AuthCallback.vue?vue&type=script&lang=ts"
import style0 from "./AuthCallback.vue?vue&type=style&index=0&id=4710a540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710a540",
  null
  
)

export default component.exports